<template>
  <ListeClientAffecter/>
</template>

<script lang="ts">
  import { defineComponent } from "vue";


import ListeClientAffecter from "@/components/GesCom/ClientAffecter/ListeClientAffecter.vue";

  export default defineComponent({
    name: "ListeClientAffecterPage",
    components: {
      
      ListeClientAffecter,
    },
  });
</script>


